/**
 * QUIÉN ENTRA A MARCAJE DE VISITA (db/192 → db/197), y quién hace qué dentro.
 *
 * El primer día la vieron ocho cuentas por NOMBRE («solo lo puedan ver los
 * usuarios cobranzas, gerenciaventas, asesor612, asesor209, centrollanos,
 * andesoccidente, master y franciscodiaz»). Desde la tarde del 2026-09-30, por
 * ROL: «ya pueden tener acceso al módulo de marcaje de visita los
 * coordinadores, asesores y usuarios master, cada uno con los parámetros de
 * seguridad que siempre colocamos» (la usuaria). COBRANZAS y GERENCIAVENTAS
 * siguen: no tienen esos roles, pero ven la bandeja de correcciones (y la
 * segunda es la que las aprueba).
 *
 * Una sola copia, y la importan el endpoint (`netlify/functions/marcaje.mts`),
 * que es el candado de verdad, el menú (`navegacion.ts`) y la página. La app
 * del teléfono es JavaScript suelto y lleva la suya en
 * `public/movil/seccion-marcaje.js`; `marcaje.test.ts` comprueba que las dos
 * digan lo mismo.
 *
 * ── LOS PARÁMETROS DE SIEMPRE (los aplica el endpoint, en SQL) ──────────────
 *  · el ASESOR ve y marca SOLO su código (NORMA 1); sin código asignado, 403;
 *  · el COORDINADOR (REGIONAL) ve solo los asesores y clientes de su zona, y NO
 *    marca: marcar es tomar el GPS en el local, y eso es del asesor;
 *  · MASTER ve todo. KEYACCOUNTS es REGIONAL con el alcance abierto y lee todo
 *    por la excepción nominal de la NORMA 1 §8 (db/161); tampoco marca.
 *
 * ── QUIÉN HACE QUÉ ──────────────────────────────────────────────────────────
 *  · MARCAR (tomar la coordenada, registrar la visita, pedir una corrección):
 *    el ASESOR, por ROL y sobre su propio código.
 *  · APROBAR una corrección de coordenada: SOLO Kenya Sánchez, con la cuenta
 *    GERENCIAVENTAS — «que las apruebe kenya» (la usuaria, 2026-10-01), y al
 *    preguntarle eligió esa cuenta (no la personal KENYA) y «solo Kenya».
 *    Hasta ese día aprobaban también COBRANZAS y MASTER (2026-09-29).
 *  · VER la bandeja de correcciones (la pestaña de la web, su lista, sus
 *    fotos y las correcciones del reporte): COBRANZAS, GERENCIAVENTAS y MASTER
 *    — «esta pestaña solo lo puede ver cobranzas, gerenciaventas y master» (la
 *    usuaria, 2026-09-30). Cobranzas y Master la siguen viendo, pero en solo
 *    lectura. Los asesores las piden desde el teléfono. Ver no es decidir: con
 *    la clave maestra se mira, pero no se aprueba.
 */

/** Los roles que ven la sección. */
export const ROLES_MARCAJE: readonly string[] = ['ASESOR', 'REGIONAL', 'MASTER', 'CONSULTAGENERAL'];   // db/273: mira, no marca

/** Las cuentas que la ven sin tener esos roles: las que miran la bandeja de correcciones. */
export const CUENTAS_MARCAJE: readonly string[] = ['COBRANZAS', 'GERENCIAVENTAS'];

/** Quién aprueba o rechaza una corrección de coordenada: Kenya, con la cuenta GERENCIAVENTAS (2026-10-01), y
 *  desde el 2026-10-14 también COBRANZAS («que el usuario de cobranzas pueda también aprobar coordenadas junto
 *  con el usuario de gerenciaventas»). */
export const APROBADORES_MARCAJE: readonly string[] = ['GERENCIAVENTAS', 'COBRANZAS'];

/** Las tres cuentas que VEN la bandeja de correcciones; solo `APROBADORES_MARCAJE` decide (MASTER, solo lectura). */
export const VISORES_CORRECCIONES: readonly string[] = ['COBRANZAS', 'GERENCIAVENTAS', 'MASTER',
  'ASISTENTEGERENCIA'];   // db/273: Daniela Palma, la consulta general — ve la bandeja, no decide

export const puedeVerMarcaje = (username: string, roles: readonly string[] = []): boolean =>
  CUENTAS_MARCAJE.includes(username) || roles.some((r) => ROLES_MARCAJE.includes(r));

export const puedeMarcar = (roles: readonly string[], username: string): boolean =>
  puedeVerMarcaje(username, roles) && roles.includes('ASESOR');

export const puedeAprobarCorreccion = (username: string): boolean => APROBADORES_MARCAJE.includes(username);

/** Quién ve la bandeja de correcciones: las tres cuentas, aunque solo una decida. */
export const puedeVerCorrecciones = (username: string): boolean => VISORES_CORRECCIONES.includes(username);
